import { cloneDeep } from 'lodash';

import { CommunicationSessionId } from '../../../../core/communication-session-id/communication-session-id';
import { SerializableObject } from '../../../../generic/serialization/serializable-object';
import { SerializableObjectSchema } from '../../../../generic/serialization/serializable-object-schema';
import { CommunicationTaskAttributesTaskQueue } from '../../communication-task-attributes/communication-task-attributes-task-queue/communication-task-attributes-task-queue';
import { CommunicationTaskNameType } from '../communication-task-name';

export abstract class CommunicationTask extends SerializableObject {
  protected type!: CommunicationTaskNameType;

  protected orgId!: string;

  protected sessionId!: CommunicationSessionId;

  protected taskQueueAttributes!: Map<string, CommunicationTaskAttributesTaskQueue>;

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    throw new Error('Error: Cannot get schema for abstract CommunicationTask');
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getType(): CommunicationTaskNameType {
    return cloneDeep(this.type);
  }

  public getOrgId(): string {
    return cloneDeep(this.orgId);
  }

  public getSessionId(): CommunicationSessionId {
    return cloneDeep(this.sessionId);
  }

  public getTaskQueueAttributes() {
    return cloneDeep(this.taskQueueAttributes);
  }

  /////////////////////////////////////////////////////////////////////////////
  // Setters
  /////////////////////////////////////////////////////////////////////////////

  public setTaskQueueAttributes(taskQueueId: string, attributes: CommunicationTaskAttributesTaskQueue): this {
    this.taskQueueAttributes.set(taskQueueId, attributes);
    return this;
  }
}
